// extracted by mini-css-extract-plugin
export default {"defaultbutton":"Login_defaultbutton__uzi6Y"};